
import React from 'react';
import { Link } from 'react-router-dom';
import "./Sealing.css";
import { useTranslation } from 'react-i18next';

function Products() {
   const { t } = useTranslation();
  return (
    <div className='products-container'>
      <div className="products-content">

        <div className='products-header'>
          <h3>{t('nav_pruduct_sealing')}</h3>
        </div>

        <div className='pro-text-promotion'>
          

          <p>{t('sealing-p-one')}</p>
          <p>{t('sealing-p-two')}</p>


        </div>


        <div className='products-features'>
          <div className='products-features-header'>
            <h3>{t('sealing-norm-header-text')}</h3>
          </div>
          <p><strong>{t('sealing-norm-p-one')}</strong>{t('sealing-norm-p-info-one')}</p>
          <p><strong>{t('sealing-norm-p-two')}</strong>{t('sealing-norm-p-info-two')}</p>
          <p><strong>{t('sealing-norm-p-three')}</strong>{t('sealing-norm-p-info-three')}</p>
          <p><strong>{t('sealing-norm-p-four')}</strong>{t('sealing-norm-p-info-four')}</p>
          <p><strong>{t('sealing-norm-p-five')}</strong>{t('sealing-norm-p-info-five')}</p>
        </div>



        <div className='info-contact'>
          <Link to="/contact" className='btn-contact'>{t('sealing-norm-button')}</Link>
        </div>

      </div>
    </div>
  )
}

export default Products
